const Sun = (props) => {

  return (
    <div className="sunAnimation">
      {props.children}
    </div>
  )
}

export default Sun;